// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for shared display components.
 * Loaded AFTER index.css, so equal-specificity rules here win by source order.
 *
 * Contents:
 *   (a) DataTable mobile card view + wrapping controls/pagination (<=576px)
 *   (b) Reusable mobile bottom-sheet pattern for modals + full-width drawers (<=576px)
 *
 * NOTE: Any page-level modal automatically gets the bottom-sheet treatment on
 * mobile simply by using the existing .modal / .modal-overlay classes from
 * index.css. Drawers get the full-width treatment via .drawer / .drawer-overlay.
 * No per-page CSS is required.
 */

/* ===========================================================================
 * (a) DataTable — mobile card view + tappable, wrapping controls
 * ======================================================================== */
@media (max-width: 576px) {
  /* Controls: stack and wrap so search / date / filter chips stay tappable */
  .table-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .controls-left,
  .controls-right {
    flex-wrap: wrap;
    width: 100%;
    gap: 10px;
  }

  .search-box {
    width: 100%;
  }

  .search-box input {
    width: 100%;
  }

  .date-filter,
  .inline-filter {
    flex: 1 1 100%;
  }

  .inline-filter-select,
  .date-picker-input {
    width: 100%;
  }

  /* Ensure interactive controls meet the 44px touch-target minimum */
  .search-box input,
  .inline-filter-select,
  .date-picker-input,
  .column-toggle-btn,
  .clear-filters-btn,
  .clear-search,
  .page-size-select,
  .pagination-btn,
  .page-number {
    min-height: 44px;
  }

  .clear-search {
    min-width: 44px;
  }

  /* Card list replaces the <table> on mobile */
  .table-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }

  .table-card {
    background: var(--bg-secondary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .table-card.clickable {
    cursor: pointer;
  }

  .table-card.clickable:active {
    background: var(--bg-tertiary);
  }

  .table-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .table-card-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    flex-shrink: 0;
  }

  .table-card-value {
    font-size: 14px;
    color: var(--text-primary);
    text-align: right;
    min-width: 0;
    word-break: break-word;
  }

  /* Actions render full-width without a label, separated from the data rows */
  .table-card-row.table-card-actions {
    margin-top: 4px;
    padding-top: 12px;
    border-top: 1px solid var(--border-color, var(--bg-tertiary));
  }

  .table-card-row.table-card-actions .table-card-value {
    flex: 1 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    text-align: left;
  }

  .table-cards .empty-state {
    padding: 32px 16px;
    text-align: center;
    color: var(--text-muted);
  }

  /* Pagination: wrap and stay tappable */
  .table-pagination {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .pagination-info {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
  }

  .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
  }

  .page-numbers {
    flex-wrap: wrap;
    justify-content: center;
  }
}

/* ===========================================================================
 * (b) Modals -> bottom sheets; drawers -> full-width (mobile)
 * Overrides index.css .modal / .modal-overlay / .drawer rules at equal
 * specificity by loading later. Page-level dialogs inherit this for free.
 * ======================================================================== */
@media (max-width: 576px) {
  /* Pin overlay content to the bottom of the screen */
  .modal-overlay {
    align-items: flex-end;
    justify-content: stretch;
    padding: 0;
  }

  /* Full-width bottom sheet: slides up, rounded top corners, internal scroll */
  .modal,
  .modal.large,
  .create-modal,
  .modal-container,
  .filter-modal {
    width: 100%;
    max-width: 100%;
    max-height: 90vh;
    border-radius: 16px 16px;
    animation: components-sheet-up 0.25s ease;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .modal-body {
    overflow-y: auto;
  }

  @keyframes components-sheet-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  /* Drawer: near-full-width side panel on mobile */
  .drawer {
    width: 92%;
    max-width: 92%;
  }

  /* Touch targets: every control in a dialog/form meets 44px on mobile */
  .modal input,
  .modal select,
  .modal textarea,
  .modal .btn,
  .modal button,
  .create-modal input,
  .create-modal select,
  .create-modal button,
  .modal-container input,
  .modal-container select,
  .modal-container textarea,
  .modal-container button,
  .refund-modal input,
  .refund-modal button {
    min-height: 44px;
    font-size: 16px;
  }

  /* Shared enterprise button is 38px on desktop; bump to 44px touch target
     on mobile across every page that uses it (page headers, action rows). */
  .ent-btn {
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/components.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;;6EAE6E;AAC7E;EACE,2EAA2E;EAC3E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA,mEAAmE;EACnE;;;;;;;;;IASE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,qCAAqC;IACrC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;EACxB;;EAEA,4EAA4E;EAC5E;IACE,eAAe;IACf,iBAAiB;IACjB,6DAA6D;EAC/D;;EAEA;IACE,SAAO;IACP,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;;;;6EAI6E;AAC7E;EACE,oDAAoD;EACpD;IACE,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;EACZ;;EAEA,6EAA6E;EAC7E;;;;;IAKE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yCAAyC;IACzC,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;;EAEA,iDAAiD;EACjD;IACE,UAAU;IACV,cAAc;EAChB;;EAEA,uEAAuE;EACvE;;;;;;;;;;;;;;IAcE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;4EAC0E;EAC1E;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Responsive overrides for shared display components.\n * Loaded AFTER index.css, so equal-specificity rules here win by source order.\n *\n * Contents:\n *   (a) DataTable mobile card view + wrapping controls/pagination (<=576px)\n *   (b) Reusable mobile bottom-sheet pattern for modals + full-width drawers (<=576px)\n *\n * NOTE: Any page-level modal automatically gets the bottom-sheet treatment on\n * mobile simply by using the existing .modal / .modal-overlay classes from\n * index.css. Drawers get the full-width treatment via .drawer / .drawer-overlay.\n * No per-page CSS is required.\n */\n\n/* ===========================================================================\n * (a) DataTable — mobile card view + tappable, wrapping controls\n * ======================================================================== */\n@media (max-width: 576px) {\n  /* Controls: stack and wrap so search / date / filter chips stay tappable */\n  .table-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .controls-left,\n  .controls-right {\n    flex-wrap: wrap;\n    width: 100%;\n    gap: 10px;\n  }\n\n  .search-box {\n    width: 100%;\n  }\n\n  .search-box input {\n    width: 100%;\n  }\n\n  .date-filter,\n  .inline-filter {\n    flex: 1 1 100%;\n  }\n\n  .inline-filter-select,\n  .date-picker-input {\n    width: 100%;\n  }\n\n  /* Ensure interactive controls meet the 44px touch-target minimum */\n  .search-box input,\n  .inline-filter-select,\n  .date-picker-input,\n  .column-toggle-btn,\n  .clear-filters-btn,\n  .clear-search,\n  .page-size-select,\n  .pagination-btn,\n  .page-number {\n    min-height: 44px;\n  }\n\n  .clear-search {\n    min-width: 44px;\n  }\n\n  /* Card list replaces the <table> on mobile */\n  .table-cards {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n  }\n\n  .table-card {\n    background: var(--bg-secondary);\n    border: 1px solid var(--border-color);\n    border-radius: var(--radius-md);\n    padding: 14px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .table-card.clickable {\n    cursor: pointer;\n  }\n\n  .table-card.clickable:active {\n    background: var(--bg-tertiary);\n  }\n\n  .table-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .table-card-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    flex-shrink: 0;\n  }\n\n  .table-card-value {\n    font-size: 14px;\n    color: var(--text-primary);\n    text-align: right;\n    min-width: 0;\n    word-break: break-word;\n  }\n\n  /* Actions render full-width without a label, separated from the data rows */\n  .table-card-row.table-card-actions {\n    margin-top: 4px;\n    padding-top: 12px;\n    border-top: 1px solid var(--border-color, var(--bg-tertiary));\n  }\n\n  .table-card-row.table-card-actions .table-card-value {\n    flex: 1;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    text-align: left;\n  }\n\n  .table-cards .empty-state {\n    padding: 32px 16px;\n    text-align: center;\n    color: var(--text-muted);\n  }\n\n  /* Pagination: wrap and stay tappable */\n  .table-pagination {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .pagination-info {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .page-numbers {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n/* ===========================================================================\n * (b) Modals -> bottom sheets; drawers -> full-width (mobile)\n * Overrides index.css .modal / .modal-overlay / .drawer rules at equal\n * specificity by loading later. Page-level dialogs inherit this for free.\n * ======================================================================== */\n@media (max-width: 576px) {\n  /* Pin overlay content to the bottom of the screen */\n  .modal-overlay {\n    align-items: flex-end;\n    justify-content: stretch;\n    padding: 0;\n  }\n\n  /* Full-width bottom sheet: slides up, rounded top corners, internal scroll */\n  .modal,\n  .modal.large,\n  .create-modal,\n  .modal-container,\n  .filter-modal {\n    width: 100%;\n    max-width: 100%;\n    max-height: 90vh;\n    border-radius: 16px 16px;\n    animation: components-sheet-up 0.25s ease;\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n\n  @keyframes components-sheet-up {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  /* Drawer: near-full-width side panel on mobile */\n  .drawer {\n    width: 92%;\n    max-width: 92%;\n  }\n\n  /* Touch targets: every control in a dialog/form meets 44px on mobile */\n  .modal input,\n  .modal select,\n  .modal textarea,\n  .modal .btn,\n  .modal button,\n  .create-modal input,\n  .create-modal select,\n  .create-modal button,\n  .modal-container input,\n  .modal-container select,\n  .modal-container textarea,\n  .modal-container button,\n  .refund-modal input,\n  .refund-modal button {\n    min-height: 44px;\n    font-size: 16px;\n  }\n\n  /* Shared enterprise button is 38px on desktop; bump to 44px touch target\n     on mobile across every page that uses it (page headers, action rows). */\n  .ent-btn {\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
